import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import {BehaviorSubject} from 'rxjs';
import { environment } from 'src/environments/environment';
import { TerminalDeliveryModel } from '../interface/terminal-delivery-model';

@Injectable({
    providedIn: 'root'
})
export class TerminalDeliveryService {
    private terminalDelivery: BehaviorSubject<any>;

    constructor(protected http: HttpClient, private auth: AuthService) {
        this.terminalDelivery = new BehaviorSubject<any>(null);
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getOffices(zip) {
        const url = environment.comunEndpoint + 'correos/offices?postCode=' + zip;

        return this.http.get(url, {headers: this.getHeaders()});
    }

    setTerminalDelivery(data: TerminalDeliveryModel) {
        this.terminalDelivery.next(data);
    }

    getTerminalDelivery() {
        return this.terminalDelivery.asObservable();
    }
}
